module.exports = __webpack_public_path__ + "img/Abaddon.57f74cba.png";